import React, { useState, useRef, useEffect } from "react";

interface RandomLoopAudioPlayerProps {
  audioUrls: string[];
  onEnded?: () => void;
}

const RandomLoopAudioPlayer: React.FC<RandomLoopAudioPlayerProps> = ({ audioUrls, onEnded }) => {
  const [selectedUrl, setSelectedUrl] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement>(null);

  // Pick a random song on mount or when audioUrls change
  useEffect(() => {
    if (audioUrls.length === 0) return;
    const idx = Math.floor(Math.random() * audioUrls.length);
    setSelectedUrl(audioUrls[idx]);
  }, [audioUrls]);

  // Play automatically when selectedUrl changes
  useEffect(() => {
    if (selectedUrl && audioRef.current) {
      audioRef.current.play();
    }
  }, [selectedUrl]);

  const handleEnded = () => {
    if (onEnded) onEnded();
  };

  return (
    <>
      {selectedUrl && (
        <audio
          ref={audioRef}
          src={selectedUrl}
          onEnded={handleEnded}
          autoPlay
          hidden
        />
      )}
    </>
  );
};

export default RandomLoopAudioPlayer;